const AUTHORITY_TYPE_ID = {
  ADMIN: 1,
  USER: 2,
  PART_TIME: 10,
  OUTSIDE_STAF: 20
}
const AUTHORITY_TYPE_LABEL = {
  ADMIN: 'user.user_administrator',
  USER: 'user.user_member',
  PART_TIME: 'user.user_member_2',
  OUTSIDE_STAF: 'user.user_member_3'
}

export default {
  AUTHORITY_TYPE_ID,
  AUTHORITY_TYPE_LABEL
}
